import React from 'react';
import './Integrations.css';

function MpesaDocs() {
  return (
    <div className="integration-page">
      <div className="page-header">
        <h1>M-Pesa Integration</h1>
        <p>Documentation and example flows for integrating M-Pesa payments (STK Push / C2B).</p>
      </div>

      <div className="container">
        <section className="doc-section">
          <h2>Overview</h2>
          <p>
            We offer M-Pesa integration services including STK Push (customer prompt), C2B collections, and reconciliation.
            Integrations are implemented server-side and require secure credentials (consumer key/secret, callback URLs).
          </p>
        </section>

        <section className="doc-section">
          <h2>Initiate STK Push (Example)</h2>
          <p>Example request to our simulated endpoint:</p>
          <pre>
{`curl -X POST http://localhost:5000/api/payments/mpesa/initiate \
  -H "Content-Type: application/json" \
  -d '{"amount":100,"phone":"+2547XXXXXXXX","accountReference":"INV-123"}'`}
          </pre>
          <p>Response (simulated):</p>
          <pre>{`{
  "success": true,
  "txId": "MPESA-161234567890",
  "status": "initiated",
  "message": "Simulated M-Pesa STK push sent"
}`}</pre>
        </section>

        <section className="doc-section">
          <h2>Callback Handling</h2>
          <p>
            M-Pesa will POST a callback to your configured endpoint when a payment completes. Verify payloads and update
            transaction status in your system. Our simulated callback endpoint is <code>/api/payments/mpesa/callback</code>.
          </p>
        </section>

        <section className="doc-section">
          <h2>Environment Variables</h2>
          <ul>
            <li><code>MPESA_CONSUMER_KEY</code></li>
            <li><code>MPESA_CONSUMER_SECRET</code></li>
            <li><code>MPESA_SHORTCODE</code></li>
            <li><code>MPESA_CALLBACK_URL</code></li>
          </ul>
        </section>

        <section className="doc-section">
          <h2>Security</h2>
          <p>
            Use HTTPS for all callbacks, validate signatures where provided, and never expose your API credentials client-side.
          </p>
        </section>
      </div>
    </div>
  );
}

export default MpesaDocs;
